import Vue       from 'vue'
import Router    from 'vue-router'
import axios     from 'axios'
import VueAxios  from 'vue-axios'
import adminView from '@/components/Admin_View'
import clienteAdminView from '@/components/View_Cliente_Admin'
import parametrosView from '@/views/View_parametros'
import managerView from '@/views/View_manager'
import estadosView from '@/views/View_administrador_estados'
import usuariosView from '@/views/View_administrador_usuarios'
import notificacionesView from '@/views/View_notificaciones'
import auditoriaView from '@/views/View_auditoria'
import moment                          from 'moment'
import 'moment/locale/es'
moment.locale('es')

Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.API_ROUTE

export default new Router({
  mode: 'history',
  routes: [
    {
      path     : '/',
      name     : 'admin',
      component: adminView
    },
    {
      path     : '/cliente',
      name     : 'client_admin',
      component: clienteAdminView
    },
    {
      path     : '/auditoria',
      name     : 'auditoria',
      component: auditoriaView
    },
    {
      path     : '/notificaciones',
      name     : 'notificaciones',
      component: notificacionesView
    },
    {
      path: '/manager',
      name: 'manager_view',
      component: managerView
    },
    {
      path: '/manager/parametros',
      name: 'parametros',
      component: parametrosView
    },
    {
      path: '/manager/usuarios',
      name: 'usuarios',
      component: usuariosView
    },
    {
      path: '/manager/estados',
      name: 'estados',
      component: estadosView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/admin.js